export default __webpack_public_path__ + "static/media/detalii_apartament_124-min.0e1361b2.jpg";